import { useRouter } from 'next/router';
import withApplicationProps from '@/evercall/application/withApplicationProps';
import evercallUrl from '@/evercall/infrastructure/evercallUrl';

export const getServerSideProps = withApplicationProps(() => ({ props: {} }));

/**
 * Redirects to user login page with evercall session propagation
 * Using in email letter for redirect user to this page, so handle next login steps on frontend side
 */
export default () => {
  const router = useRouter();
  const destination = evercallUrl.getLoginUrl();
  router.push(destination);
  return null;
};
